import actions from './actions';

const {
  ADD_COMPANY_BEGIN,
  ADD_COMPANY_SUCCESS,
  ADD_COMPANY_ERR,

  GET_COMPANIES_BEGIN,
  GET_COMPANIES_SUCCESS,
  GET_COMPANIES_ERR,

  UPDATE_COMPANY_BEGIN,
  UPDATE_COMPANY_SUCCESS,
  UPDATE_COMPANY_ERR,

  DELETE_COMPANY_BEGIN,
  DELETE_COMPANY_SUCCESS,
  DELETE_COMPANY_ERR,
} = actions;

const initialState = {
  data: [],
  loading: false,
  error: null,
};

const companyReducer = (state = initialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case ADD_COMPANY_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case ADD_COMPANY_SUCCESS:
      return {
        ...state,
        error: false,
        loading: false,
      };

    case ADD_COMPANY_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    case GET_COMPANIES_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case GET_COMPANIES_SUCCESS:
      return {
        ...state,
        data,
        error: false,
        loading: false,
      };

    case GET_COMPANIES_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    case DELETE_COMPANY_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case DELETE_COMPANY_SUCCESS:
      return {
        ...state,
        error: false,
        data,
        loading: false,
      };

    case DELETE_COMPANY_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    case UPDATE_COMPANY_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case UPDATE_COMPANY_SUCCESS:
      return {
        ...state,
        error: false,
        loading: false,
      };

    case UPDATE_COMPANY_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    default:
      return state;
  }
};

export { companyReducer };
